import React from 'react';
import { Modal } from 'react-bootstrap';
import '../../styles/components/confirm-modal.scss';
import { Loader2, X } from 'lucide-react';

export class ConfirmModal extends React.Component {
  render() {
    const {
      show,
      onClose,
      title = 'Confirm',
      message = 'Are you sure?',
      onConfirm,
      confirmText = 'Confirm',
      cancelText,
      children,
      closeBtn = false,
      loading,
    } = this.props;

    return (
      <Modal show={show} onHide={onClose} className="confirm-modal-modern">
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
          {closeBtn && (
            <button className="custom-close-btn" onClick={onClose}>
              <X size={22} />
            </button>
          )}
        </Modal.Header>

        <Modal.Body>{children ? children : <p className="modal-message">{message}</p>}</Modal.Body>

        <Modal.Footer>
          {cancelText && (
            <button className="modal-btn btn-cancel" onClick={onClose}>
              {cancelText}
            </button>
          )}
          {onConfirm && (
            <button className="modal-btn btn-confirm" onClick={onConfirm} disabled={loading}>
              {loading ? (
                <span
                  style={{
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                  }}
                >
                  <Loader2 className="animate-spin" size={16} /> Loading
                </span>
              ) : (
                confirmText
              )}
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}
